// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JOxwh","question":"styles_question__1j0bU","description":"styles_description__3oI69"};